import { ConceptSponsor } from '../models/Entities/Contracts/ConceptSponsor';
import { NewConceptSponsor } from '../models/Entities/Contracts/NewConceptSponsor';
import { IResult } from '../models/HttpResult';

// Functions
import * as Functions from '../functions/common';

// Error Tracer
import * as Sentry from '@sentry/react';

const BaseURL = process.env.REACT_APP_BILLER_API_GATEWAY + 'sponsors/contracts/';

export const GetConceptSponsors = async (sponsorId: string, token: string): Promise<ConceptSponsor[]> => {
  const requestURL: string = BaseURL + sponsorId + '/concepts';

  try {
    const response: ConceptSponsor[] = await fetch(requestURL, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
    })
      .then((rawResponse) => {
        if (!rawResponse.ok) {
          Sentry.captureException(rawResponse);
          throw rawResponse;
        }
        return rawResponse.json() as Promise<IResult<ConceptSponsor[]>>;
      })
      .then((data: IResult<ConceptSponsor[]>) => data.data)
      .catch((error: any) =>
        error.text().then((body: any) => {
          throw Functions.HttpErrorHandler(body, error);
        })
      );

    return response;
  } catch (error: any) {
    Sentry.captureException(error);
    throw error;
  }
};

export const GetConceptSponsorById = async (conceptSponsorId: number, token: string): Promise<ConceptSponsor> => {
  const requestURL: string = BaseURL + 'concepts/' + conceptSponsorId;

  try {
    const response: ConceptSponsor = await fetch(requestURL, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
    })
      .then((rawResponse) => {
        if (!rawResponse.ok) {
          Sentry.captureException(rawResponse);
          throw rawResponse;
        }
        return rawResponse.json() as Promise<IResult<ConceptSponsor>>;
      })
      .then((data: IResult<ConceptSponsor>) => data.data)
      .catch((error: any) =>
        error.text().then((body: any) => {
          throw Functions.HttpErrorHandler(body, error);
        })
      );

    return response;
  } catch (error: any) {
    Sentry.captureException(error);
    throw error;
  }
};

export const CreateConceptSponsor = async (newConceptSponsor: NewConceptSponsor, token: string): Promise<ConceptSponsor> => {
  const requestURL: string = BaseURL + 'concepts';

  try {
    const response: ConceptSponsor = await fetch(requestURL, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
      body: JSON.stringify(newConceptSponsor),
    })
      .then((rawResponse) => {
        if (!rawResponse.ok) {
          Sentry.captureException(rawResponse);
          throw rawResponse;
        }
        return rawResponse.json() as Promise<IResult<ConceptSponsor>>;
      })
      .then((data: IResult<ConceptSponsor>) => data.data)
      .catch((error: any) =>
        error.text().then((body: any) => {
          throw Functions.HttpErrorHandler(body, error);
        })
      );

    return response;
  } catch (error: any) {
    Sentry.captureException(error);
    throw error;
  }
};

export const UpdateConceptSponsor = async (conceptSponsor: ConceptSponsor, token: string): Promise<ConceptSponsor> => {
  const requestURL: string = BaseURL + 'concepts';

  try {
    const response: ConceptSponsor = await fetch(requestURL, {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
      body: JSON.stringify(conceptSponsor),
    })
      .then((rawResponse) => {
        if (!rawResponse.ok) {
          Sentry.captureException(rawResponse);
          throw rawResponse;
        }
        return rawResponse.json() as Promise<IResult<ConceptSponsor>>;
      })
      .then((data: IResult<ConceptSponsor>) => data.data)
      .catch((error: any) =>
        error.text().then((body: any) => {
          throw Functions.HttpErrorHandler(body, error);
        })
      );

    return response;
  } catch (error: any) {
    Sentry.captureException(error);
    throw error;
  }
};

export const DeleteConceptSponsor = async (conceptSponsorId: number, token: string): Promise<void> => {
  const requestURL: string = BaseURL + 'concepts/' + conceptSponsorId;

  try {
    const response: void = await fetch(requestURL, {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
    })
      .then((rawResponse) => {
        if (!rawResponse.ok) {
          Sentry.captureException(rawResponse);
          throw rawResponse;
        }
        return rawResponse.json() as Promise<IResult<void>>;
      })
      .then((data: IResult<void>) => data.data)
      .catch((error: any) =>
        error.text().then((body: any) => {
          throw Functions.HttpErrorHandler(body, error);
        })
      );

    return response;
  } catch (error: any) {
    Sentry.captureException(error);
    throw error;
  }
};
